import React from 'react';
import { Outlet } from 'react-router-dom';

export default function MainPanel({ header, children }) {
  return (
    <main className="hmisx-main">
      {header ? (
        <div className="hmisx-head" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
          {header}
        </div>
      ) : null}
      <section className="hmisx-content" style={{ flex: 1, overflow: 'auto', padding: 0 }}>
        {children || <Outlet />}
      </section>
    </main>
  );
}
